import { render, staticRenderFns } from "./property-selected.vue?vue&type=template&id=7af867e3&scoped=true"
import script from "./property-selected.vue?vue&type=script&lang=js"
export * from "./property-selected.vue?vue&type=script&lang=js"
import style0 from "./property-selected.vue?vue&type=style&index=0&id=7af867e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af867e3",
  null
  
)

export default component.exports